import React from 'react'
import { Link } from 'react-router-dom'
import ls from 'local-storage'
import * as CONFIG from './_config'

class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    };


    showRegister(e) {

        let redirectToPath = window.location.pathname;

        if(window.location.hash !== '')
            redirectToPath = redirectToPath + window.location.hash;

        // console.log(window.location, window.location.hash, redirectToPath);
        // ls.set('redirectTo', redirectToPath);
        ls.set('redirectTo',window.location.href);
        this.props.history.push(CONFIG.DATA.ALLOW_LINK_CARD_REGISTRATION ? "/register":"/simple-register");
        return false;
    }

    render() {
var route_Name = 'Loyalty'
        return (
                <div>
                    <div className="main-container full-width pt-5 mt-5">

                        {CONFIG.DATA.THEME == 2 ?
                            <section id="apus-breadscrumb" className="breadcrumb-page apus-breadscrumb"
                                     style={{backgroundColor: '#f3ffd9'}}>
                                <div className="container">
                                    <div className="wrapper-breads">
                                        <div className="wrapper-breads-inner">
                                            <div className="breadscrumb-inner">
                                                <h2 className="bread-title">{route_Name}</h2>
                                                <ol className="breadcrumb">
                                                    <li><a href="/">Home</a></li>
                                                    <li><span className="active">{route_Name}</span></li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            :
                        <div className="title-breadcrumb">
                            <div className="container">
                                <div className="title-breadcrumb-inner">
                                    <header className="entry-header">
                                        <h1 className="entry-title">Loyalty</h1>
                                    </header>
                                    <div className="breadcrumbs"><Link to="/">Home</Link><span className="separator">/</span><span> Loyalty</span></div>
                                </div>
                            </div>

                        </div>}

                        <div className='container'>
                            <div className="row">

                                <div className="vc_col-xs-12">
                                    <div className="page-content default-page">

                                        <article id="post-8436"
                                                 className="post-8436 page type-page status-publish hentry">

                                            <div className="entry-content">
                                                <div className="vc_row wpb_row vc_row-fluid">
                                                    <div className="row-container">
                                                        <div className="wpb_column vc_column_container vc_col-sm-12">
                                                            <div className="vc_column-inner">
                                                                <div className="wpb_wrapper"><h2
                                                                    style={{'fontSize': '42px',textAlign: 'center',fontFamily:'Bubblegum Sans','fontWeight':400,fontStyle:'normal'}}
                                                                    className="vc_custom_heading">Start Saving
                                                                    Money &amp; Time...Download the Mobile App
                                                                    Today!</h2>
                                                                    <div
                                                                        className="wpb_single_image wpb_content_element vc_align_left">

                                                                        <figure className="wpb_wrapper vc_figure">
                                                                            <div
                                                                                className="vc_single_image-wrapper vc_box_border_grey">
                                                                                <img width="960" height="350"
                                                                                     src="/assets/images/loyalty-v36.jpg"
                                                                                     className="vc_single_image-img attachment-full"
                                                                                     alt=""
                                                                                     srcSet="/assets/images/loyalty-v36.jpg"
                                                                                     sizes="(max-width: 960px) 100vw, 960px"/>
                                                                            </div>
                                                                        </figure>
                                                                    </div>
                                                                    <div className="vc_empty_space" style={{height: '10px'}}>
                                                                        <span className="vc_empty_space_inner"/>
                                                                    </div>

                                                                    <div
                                                                        className="wpb_text_column wpb_content_element ">
                                                                        <div className="wpb_wrapper">
                                                                            <p className='bold-title '>
                                                                                <span style={{'fontSize': '14pt'}} className='float-left'>
                                                                                    <a href={CONFIG.DATA.APP_URL_IOS} style={CONFIG.DATA.THEME == 2?{"color":'#008000'}:{}}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer">Download for iOS
                                                                                    </a>&nbsp;&nbsp;&nbsp;|&nbsp; &nbsp;
                                                                                    <a href={CONFIG.DATA.APP_URL_ANDROID} style={CONFIG.DATA.THEME == 2?{"color":'#008000'}:{}}
                                                                                       target="_blank"
                                                                                       rel="noopener noreferrer">Download for Android</a>
                                                                              
                                                                              {CONFIG.DATA.RSA_SUBDOMAIN ==='raysapplemarket'?
                                                                            <>
                                                                         
                                                                              &nbsp;&nbsp;&nbsp;|&nbsp; &nbsp;


                                                                              <a href={`https://raysapplemarket.rsapwaapp.com/`} style={CONFIG.DATA.THEME == 2?{"color":'#008000'}:{}}
                                                                                       target="_blank"
                                                                                       rel="noopener noreferrer">Download PWA App</a>
                                                                              </>
                                                                              :''
                                                                              }
                                                                                </span>
                                                                            </p>

                                                                        </div>
                                                                    </div>


                                                                    



                                                                    <div className="vc_empty_space"
                                                                         style={{height: '10px'}}>
                                                                        <span className="vc_empty_space_inner"/></div>

                                                                    { CONFIG.DATA.BACKEND_HOST == "renfroes" ?
                                                                    <div>
                                                                        <img src="/assets/images/about/renfroes.jpg" />
                                                                    </div>
                                                                    :
                                                                    <h2 style={{color: 'black',fontSize: '32px','textAlign': 'left','fontFamily':'Bubblegum Sans','fontWeight':400,'fontStyle':'normal'}}
                                                                        className="vc_custom_heading">
                                                                        <Link to="#" style={{color: 'black'}}>- Earn
                                                                        Rewards on every visit<br/>
                                                                        - Free items and exclusive giveaways<br/>
                                                                        - Hundreds of offers on items you already
                                                                        buy!<br/>
                                                                        - Start saving more time and money…download
                                                                        the mobile app today!</Link>
                                                                    </h2>
                                                                    }

                                                                    <div style={{    backgroundColor: 'rgb(238, 238, 238)'}} className="vc_row wpb_row vc_inner vc_row-fluid vc_custom_1555168419584 vc_row-has-fill vc_row-o-content-middle vc_row-flex">
                                                                        <div className="wpb_column vc_column_container vc_col-sm-9">
                                                                            <div className="vc_column-inner">
                                                                                <div className="wpb_wrapper">
                                                                                    <h3
                                                                                    style={{textAlign: 'center',fontFamily:'Bubblegum Sans',fontWeight:'400',fontStyle:'normal'}}
                                                                                    className="vc_custom_heading">No
                                                                                    Phone? No Problem. Receive great
                                                                                    deals by clicking Here.</h3>
                                                                                    <div className="vc_empty_space" style={{'height': '20px'}}>
                                                                                        <span className="vc_empty_space_inner"/>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            className="wpb_column vc_column_container vc_col-sm-3">
                                                                            <div className="vc_column-inner">
                                                                                <div className="wpb_wrapper">
                                                                                    <div className="vc_empty_space"
                                                                                         style={{'height': '20px'}}><span
                                                                                        className="vc_empty_space_inner"/>
                                                                                    </div>
                                                                                    <div
                                                                                        className="vc_btn3-container vc_btn3-center">
                                                                                        <Link className="vc_general vc_btn3 vc_btn3-size-md vc_btn3-shape-round vc_btn3-style-outline vc_btn3-block vc_btn3-color-danger"
                                                                                          to="#" onClick={ (e) => {this.showRegister(e) } }
                                                                                           >Register</Link></div>
                                                                                    <div className="vc_empty_space"
                                                                                         style={{height: '20px'}}>
                                                                                        <span className="vc_empty_space_inner"/>
                                                                                    </div>
                                                                                    <div
                                                                                        className="vc_btn3-container vc_btn3-center">
                                                                                        <Link className="vc_general vc_btn3 vc_btn3-size-md vc_btn3-shape-round vc_btn3-style-outline vc_btn3-block vc_btn3-color-success"
                                                                                           to='login'
                                                                                           title="">Sign in to
                                                                                            Account</Link></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </article>
                                        <div id="comments" className="comments-area">


                                        </div>
                                        {/*#comments .comments-area */}                         </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


        );
    }
}
export default Login;



